import { assert } from '@ember/debug';
import type { Column } from 'slickgrid';
import type { ColumnFilter } from '../components/aditools-device-table.ts';
import type { DeviceTableDeviceData } from '@ebiz/aditools-databook';
import type { FilterValues } from './selection-filter.ts';

export default class CommentFilter implements ColumnFilter<DeviceTableDeviceData> {
  filterValues: FilterValues[];
  value: string;
  qaName?: string;
  constructor(filterValues: FilterValues[], initialValue?: string, qaName?: string) {
    this.filterValues = filterValues;
    this.value = initialValue ? initialValue : '';
    this.qaName = qaName;
  }

  populate(column: Column<DeviceTableDeviceData>): HTMLElement {
    if (!column) {
      throw 'column passed to populate is invalid';
    }
    const selection = this.generateDOMElement(column);
    selection.value = this.value;
    assert('At least one element is always generated', selection);
    return selection;
  }

  generateDOMElement(column: Column<DeviceTableDeviceData>): HTMLSelectElement {
    let options = '';
    for (const item of this.filterValues) {
      options += `<option value="${item.value}">${item.display}</option>`;
    }
    const selectElement = document.createElement('select');
    selectElement.id = `filter-${column.id}`;
    selectElement.ariaLabel = `Select ${column.name}`;
    selectElement.setAttribute('data-column-id', column.id.toString());
    selectElement.className = 'slickgrid-filter-selection';
    if (this.qaName) {
      selectElement.setAttribute('data-qa-element', `device_table_${this.qaName}_select`);
    }
    selectElement.innerHTML = options;
    return selectElement;
  }

  update(element: HTMLInputElement): void {
    this.value = element.value;
  }

  unpack(packedValues: string): void {
    if (packedValues) {
      const initialValues = JSON.parse(packedValues);
      if (Object.prototype.hasOwnProperty.call(initialValues, 'value')) {
        this.value = initialValues.value;
      }
    }
  }

  reset(): void {
    this.value = '';
  }

  pack(): string {
    return JSON.stringify({ value: this.value });
  }

  hasValue(): boolean {
    return this.value !== '';
  }

  filter(field: string): boolean {
    const pieces = field ? field.split(':') : [];
    if (this.value) {
      const parm = this.filterValues.find((aParm: { value: string }) => {
        return this.value === aParm.value;
      });
      return pieces[0] === (parm?.match ? parm?.match : parm?.value);
    }
    return true;
  }
}
